export const SET_BANK_STATEMENTS = 'SET_BANK_STATEMENTS';
export const SET_BANK_STATEMENT = 'SET_BANK_STATEMENT';
export const ADD_BANK_STATEMENT = 'ADD_BANK_STATEMENT';
export const ADD_BANK_STATEMENTS = 'ADD_BANK_STATEMENTS';
export const UPDATE_BANK_STATEMENT = 'UPDATE_BANK_STATEMENT';
export const REMOVE_BANK_STATEMENT = 'REMOVE_BANK_STATEMENT';
export const CLEAR_BANK_STATEMENT = 'CLEAR_BANK_STATEMENT';
export const CLEAR_BANK_STATEMENTS = 'CLEAR_BANK_STATEMENTS';
